import React, { Fragment } from 'react';

const ClientInfo = ({ client, clientLoading }) => {
  return (
    <Fragment>
      {clientLoading ? (
        <div className='card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0 admin-list mb-2 h-max-content'>
          <div className='d-flex justify-content-center align-items-center h-100'>
            <div class='spinner-border txt-primary' role='status'>
              <span class='visually-hidden'>Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <div className='card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0 admin-list mb-2 h-max-content '>
          <div className='mb-3'>
            <h5 className='fw-bold'>id</h5>
            <div className=''>{client.id}</div>
          </div>
          <div className='mb-3'>
            <h5 className='fw-bold'>Title</h5>
            <div className=''>{client.title}</div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default ClientInfo;
